/**
 * Category display names — same slug keys as the home CategoryFilter
 * (`category.feeding`, `category.bath-&-changing`, `category.all`, …).
 */

/** Match CategoryFilter: lower-case name with spaces → hyphens (keeps & etc.). */
export function categorySlugFromName(name: string): string {
    return name.trim().toLowerCase().replace(/\s/g, '-');
}

/**
 * Translated category label for the current language.
 * Falls back to the canonical API name when no translation key exists.
 * "All Items" uses key `category.all` (not `category.all-items`).
 */
export function translateCategoryName(
    t: (key: string, params?: Record<string, unknown>) => string,
    name: string
): string {
    if (!name?.trim()) return name ?? '';
    const trimmed = name.trim();
    if (trimmed === 'All Items' || categorySlugFromName(trimmed) === 'all') {
        const allKey = 'category.all';
        const allTr = t(allKey);
        return allTr === allKey ? trimmed : allTr;
    }
    const key = `category.${categorySlugFromName(trimmed)}`;
    const translated = t(key);
    return translated === key ? trimmed : translated;
}
